export const SEARCH_NAV_CONFIG = {
    simpleSearch: {
        'routeName': 'AdvanceSimple',
        'url': '/search/input/simple'
    },
    fieldSearch: {
        'routeName': 'AdvanceField',
        'url': '/search/input/field'
    },
    expertSearch: {
        'routeName': 'AdvanceProject',
        'url': '/search/input/field/project'
    },
    bulkSearch: {
        'routeName': 'AdvanceBulk',
        'url': '/search/input/bulk'
    },
    semanticSearch: {
        'routeName': 'AdvanceSemantic',
        'url': '/search/input/semantic'
    },
    imageSearch: {
        'routeName': 'AdvanceImage',
        'url': '/search/input/image'
    },
    divergent: {
        'routeName': 'AdvanceExpand',
        'url': '/search/input/expand'
    },
    classification: {
        'routeName': 'AdvanceClassification',
        'url': '/search/input/classification'
    },
    legalSearch: {
        'routeName': 'AdvanceLegal',
        'url': '/search/input/legal'
    },
    legalCase: {
        'routeName': 'AdvanceLegalCase',
        'url': '/search/input/legal-case'
    },
    npl: {
        'routeName': 'AdvanceNpl',
        'url': '/search/input/npl'
    },
};

export const LOCAL_ROUTENAME_MODULES = [
    'AdvanceSimple',
    'AdvanceField',
    'AdvanceBulk',
    'AdvanceProject',
    'AdvanceSemantic',
    'AdvanceImage',
    'AdvanceExpand',
    'AdvanceClassification',
    'AdvanceLegal',
    'AdvanceLegalCase',
    'AdvanceNpl',
    'historyQuerySavedSearchesView'
];

export const DEFAULT_CLOSE_NAV_MODULES = [
    'PatentResult',
    'ImageResult',
    'CaseResult'
];

export const INACTIVE_SEARCH_NAV_CONFIG = [
    'divergent',
    'classification',
    'legalSearch',
    'npl',
]
